import ListOccurrences from './ListOccurrences';

export default ListOccurrences;
